import React from 'react';
import { useInterestList } from '../context/InterestListContext';
import { Heart, HeartStraight } from 'phosphor-react';
import { trackAddToInterest } from '../utils/analytics';
import './AddToInterestButton.css';

const AddToInterestButton = ({ 
  productId, 
  className = '', 
  size = 'medium',
  showText = true,
  quantity = 1 
}) => {
  const { 
    addToInterestList, 
    removeFromInterestList, 
    isInInterestList
  } = useInterestList();

  const isInList = isInInterestList(productId);

  const handleClick = () => {
    if (isInList) {
      removeFromInterestList(productId);
      // Track remoção da lista de interesse
      trackAddToInterest(productId, 'remove');
    } else {
      addToInterestList(productId, quantity);
      // Track adição à lista de interesse
      trackAddToInterest(productId, 'add');
    }
  };

  const baseClass = `add-to-interest-btn ${size} ${className}`;
  const stateClass = isInList ? 'in-list' : 'not-in-list';

  return (
    <button
      onClick={handleClick}
      className={`${baseClass} ${stateClass}`}
      title={isInList ? 'Remover da lista de interesse' : 'Adicionar à lista de interesse'}
    >
      {isInList ? (
        <HeartStraight size={
          className.includes('detail-page-primary') ? 22 : 
          size === 'small' ? 16 : 
          size === 'large' ? 24 : 20
        } weight="fill" />
      ) : (
        <Heart size={
          className.includes('detail-page-primary') ? 22 : 
          size === 'small' ? 16 : 
          size === 'large' ? 24 : 20
        } />
      )}
      {showText && (
        <span className="btn-text">
          {isInList ? 'Na Lista' : 'Adicionar'}
        </span>
      )}
    </button>
  );
};

export default AddToInterestButton;
